import { createSlice } from '@reduxjs/toolkit'

const TAB_KEYS = ['meeting_types', 'single_use_links', 'polls']

const getTabByContentKey = (contentKey) => (TAB_KEYS.includes(contentKey) ? contentKey : null)

const initialState = {
  pageStack: [],
  headerTags: [],
  selectedSection: null,
  selectedTab: null
}

const slice = createSlice({
  name: 'contextualHelp',
  initialState,
  reducers: {
    hideContextualHelp() {
      return initialState
    },
    showContextualHelp(state, { payload }) {
      const { contentKey, selectedTab } = payload
      state.pageStack = [contentKey]
      state.selectedTab = selectedTab || getTabByContentKey(contentKey)
    },
    pushPage(state, { payload }) {
      const { page } = payload
      const currentPage = state.pageStack[-1]
      if (page !== currentPage) {
        state.pageStack = [page, ...state.pageStack]
      }
    },
    popPage(state) {
      state.pageStack = state.pageStack.slice(1)
    },
    setHeaderTags(state, { payload }) {
      const { headerTags } = payload
      state.headerTags = headerTags
      state.selectedSection = headerTags[0]
    },
    setSelectedSection(state, { payload }) {
      const { selectedSection } = payload
      state.selectedSection = selectedSection
    },
    resetSelectedSection(state) {
      state.selectedSection = state.headerTags
        ? state.headerTags[0]
        : null
    },
    setSelectedTab(state, { payload }) {
      const { selectedTab } = payload
      state.selectedTab = selectedTab
    }
  }
})

export const { reducer } = slice
export const {
  showContextualHelp,
  hideContextualHelp,
  pushPage,
  popPage,
  setHeaderTags,
  setSelectedSection,
  resetSelectedSection,
  setSelectedTab
} = slice.actions
